module.exports = __webpack_public_path__ + "static/media/logo_white.4898c955.svg";